import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { CgWebsite } from "react-icons/cg";
import { BsGithub, BsArrowsFullscreen } from "react-icons/bs";
import "./ProjectCards.css"; // Add a CSS file for custom styles

function ProjectCards(props) {
  return (
    <Card className="project-card-view" onClick={props.onClick}>
      <div className="card-image-container">
        <Card.Img
          variant="top"
          src={props.imgPath}
          alt="card-img"
          className="card-image"
        />
      </div>
      <Card.Body>
        <Card.Title>{props.title}</Card.Title>
        <Card.Text style={{ textAlign: "justify" }}>
          {props.description}
        </Card.Text>
        {/* Add a clickable indicator */}
        <div className="clickable-indicator d-flex justify-content-center align-items-center my-3">
          <BsArrowsFullscreen /> Click to view more
        </div>
        <Button variant="primary" href={props.ghLink} target="_blank">
          <BsGithub /> &nbsp;
          {props.isBlog ? "Blog" : "GitHub"}
        </Button>
        {"\n"}
        {"\n"}

        {/* If the component contains Demo link and if it's not a Blog then, it will render the below component  */}
        {!props.isBlog && props.demoLink && (
          <Button
            variant="primary"
            href={props.demoLink}
            target="_blank"
            style={{ marginLeft: "10px" }}
          >
            <CgWebsite /> &nbsp;
            {"Demo"}
          </Button>
        )}

        
      </Card.Body>
    </Card>
  );
}

export default ProjectCards;
